import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCrypto from 'vue-cryptojs';
Vue.use(VueCrypto);

/* Vue Select */
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

/* Vue i18n */
import i18n from './i18n';

/* Vue Tooltip */
import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  popover: {
    defaultWrapperClass: 'pb-wrapper',
  }
})

/* Vue Scrollto */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

/* Vue Notifications */
import Notifications from 'vue-notification'
Vue.use(Notifications)

/* Vue loading */
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

/* CryptoJS */
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)

import ZoomOnHover from "vue-zoom-on-hover";
Vue.use(ZoomOnHover);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
